import React from "react";
import { Link } from "react-router-dom";
import LogoSvg from "./LogoSvg";

export interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  className = "w-auto",
}) => {
  return (
    <Link
      to="/"
      className={`ttnc-logo inline-block text-primary-6000 focus:outline-none focus:ring-0 ${className}`}
    >
      <div className="hidden md:block">
        <LogoSvg />
      </div>
    </Link>
  );
};

export default Logo;
